export default "__VITE_ASSET__BKcOkLh8__"